module.exports = __webpack_public_path__ + "media/application/images/company/secondary_nav/need-a-challenge-5d6d18f6792718b8aa761ae44e40c6d2.jpg";